/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

/**
 * LabelKey defines predefined keys for localized UI labels.
 * @Example No example provided
 */
export enum CoinbaseProfileMenuLabelKey {
  UNSPECIFIED = 'UNSPECIFIED',
  OTHER_ACCOUNTS = 'OTHER_ACCOUNTS',
  ADD_ACCOUNT = 'ADD_ACCOUNT',
  QUICKSTART = 'QUICKSTART',
  DEMO_APPS = 'DEMO_APPS',
  SDKS = 'SDKS',
  STATUS = 'STATUS',
  CANNY = 'CANNY',
  API_REFERENCE = 'API_REFERENCE',
}
export const getCoinbaseProfileMenuLabelKeyErrors = (
  value: unknown,
): { fieldName: string; error: string }[] => {
  if (process.env.NODE_ENV === 'production') return [];
  if (!Object.values(CoinbaseProfileMenuLabelKey).includes(value as any)) {
    return [{ fieldName: '', error: ` ${value} is not a valid CoinbaseProfileMenuLabelKey.` }];
  } else {
    return [];
  }
};

const validateCoinbaseProfileMenuLabelKey = (value: unknown) => {
  const errors = getCoinbaseProfileMenuLabelKeyErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: CoinbaseProfileMenuLabelKey data does not match contract.`,
      errors,
    );
  }
};
